import TabsCardsContainer from './TabsCardsContainer';

export { type TabsCardsContainerProps } from './TabsCardsContainer';
export default TabsCardsContainer;
